import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaPinterestSquare,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";


export const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-3 col-sm-6">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <h3>About us</h3>
                </div>
                <p>
                  Who sat upright, raising a heavy fur muff that covered the
                  whole of her lower arm towards the viewer. Gregor then turned
                  to
                </p>
                <div className="social">
                  <ul>
                    <li>
                      <NavLink href="#">
                        <FaFacebook />
                      </NavLink>
                    </li>
                    <li>
                      <NavLink href="#">
                        <FaTwitter />
                      </NavLink>
                    </li>
                    <li>
                      <NavLink href="#">
                        <FaLinkedin />
                      </NavLink>
                    </li>
                    <li>
                      <NavLink href="#">
                        <FaPinterestSquare />
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col col-lg-3 col-md-3 col-sm-6">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Important Links</h3>
                </div>
                <ul>
                  <li>
                    <NavLink href="#">About us</NavLink>
                  </li>
                  <li>
                    <NavLink href="#">The team</NavLink>
                  </li>
                  <li>
                    <NavLink href="#">Our services</NavLink>
                  </li>
                  <li>
                    <NavLink href="#">Contact</NavLink>
                  </li>
                </ul>
                <ul>
                  <li>
                    <NavLink href="#">Provacu Policy</NavLink>
                  </li>
                  <li>
                    <NavLink href="#">FAQ</NavLink>
                  </li>
                  <li>
                    <NavLink href="#">News</NavLink>
                  </li>
                  <li>
                    <NavLink href="#">Testimonials</NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-3 col-sm-6">
              <div className="widget contact-widget service-link-widget">
                <div className="widget-title">
                  <h3>Address Location</h3>
                </div>
                <ul>
                  <li>House no 25, dreen street, melborn Dowltown</li>
                  <li>Phone: ++8525120</li>
                  <li>Office Time: 8AM- 4PM</li>
                  <li>Email: demo@ex.com</li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-3 col-sm-6">
              <div className="widget newsletter-widget">
                <div className="widget-title">
                  <h3>Newsletter</h3>
                </div>
                <p>You will be notified when somthing new will be appear.</p>
                <form>
                  <div className="input-1">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address *"
                      required
                    />
                  </div>
                  <div className="submit clearfix">
                    <button type="submit">
                      <MdEmail />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lower-footer">
        <div className="container">
          <div className="row">
            <div className="separator"></div>
            <div className="col col-xs-12">
              <p className="copyright">
                Copyright &copy; 2019 Nictorys. All rights reserved.
              </p>
              <div className="short-links">
                <ul>
                  <li>
                    <NavLink href="#">Privacy</NavLink>
                  </li>
                  <li>
                    <NavLink href="#">Terms of Use</NavLink>
                  </li>
                  <li>
                    <NavLink href="#">Cookies</NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
